import { render, staticRenderFns } from "./ChangeMemberPasswords.vue?vue&type=template&id=e04b670a&"
import script from "./ChangeMemberPasswords.vue?vue&type=script&lang=js&"
export * from "./ChangeMemberPasswords.vue?vue&type=script&lang=js&"
import style0 from "./ChangeMemberPasswords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports